import { stringArrayToObject } from '../../utils/array';

import { loadVendorDetails, loadVendorProducts } from '../../services/DatabaseService';

export const actions = stringArrayToObject([
  'CLEAR',
  'LOAD_DETAILS_START',
  'LOAD_DETAILS_SUCCESS',
  'LOAD_DETAILS_FAIL',
  'LOAD_CATALOG_START',
  'LOAD_CATALOG_SUCCESS',
  'LOAD_CATALOG_FAIL',
], '@@VENDOR_DETAILS');

const privateActionCreators = {
  loadDetailsStart() {
    return {
      type: actions.LOAD_DETAILS_START,
    };
  },
  loadDetailsSuccess(vendor) {
    return {
      type: actions.LOAD_DETAILS_SUCCESS,
      payload: { vendor },
    };
  },
  loadDetailsFail(error) {
    return {
      type: actions.LOAD_DETAILS_FAIL,
      payload: { error },
    };
  },
  loadCatalogStart(page, { search }) {
    return {
      type: actions.LOAD_CATALOG_START,
      payload: { page, search },
    };
  },
  loadCatalogSuccess({
    products, page, totalPages, total, limit,
  }) {
    return {
      type: actions.LOAD_CATALOG_SUCCESS,
      payload: {
        products, page, totalPages, total, limit,
      },
    };
  },
  loadCatalogFail(error) {
    return {
      type: actions.LOAD_CATALOG_FAIL,
      payload: { error },
    };
  },
};

export const actionCreators = {
  clear() {
    return {
      type: actions.CLEAR,
    };
  },
  loadVendorDetails(id) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadDetailsStart());
      const response = await loadVendorDetails(id);
      if (response.ok) {
        dispatch(privateActionCreators.loadDetailsSuccess(response.vendor));
      } else {
        dispatch(privateActionCreators.loadDetailsFail(response.error));
      }
    };
  },
  loadVendorCatalog(id, page = 1, options = {}) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadCatalogStart(page, options));
      const response = await loadVendorProducts(id, page, options);
      if (response.ok) {
        dispatch(privateActionCreators.loadCatalogSuccess(response));
      } else {
        dispatch(privateActionCreators.loadCatalogFail(response.error));
      }
    };
  },
  changePagination(id, limit, { search = null } = {}) {
    return actionCreators.loadVendorCatalog(id, 1, { limit, search });
  },
};



// WEBPACK FOOTER //
// ./src/redux/VendorDetails/actions.js